import { render } from "./AnnouncementPopup.vue?vue&type=template&id=08012b87"
import script from "./AnnouncementPopup.vue?vue&type=script&lang=js"
export * from "./AnnouncementPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../kaicms_vue_250623/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__